import { render, staticRenderFns } from "./layouts.vel.037d6735.vue?vue&type=template&id=7d69c156"
import script from "./layouts.vel.037d6735.vue?vue&type=script&lang=js"
export * from "./layouts.vel.037d6735.vue?vue&type=script&lang=js"
import style0 from "./layouts.vel.037d6735.vue?vue&type=style&index=0&id=7d69c156&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d69c156')) {
      api.createRecord('7d69c156', component.options)
    } else {
      api.reload('7d69c156', component.options)
    }
    module.hot.accept("./layouts.vel.037d6735.vue?vue&type=template&id=7d69c156", function () {
      api.rerender('7d69c156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = ".nuxt/layouts.vel.037d6735.vue"
export default component.exports